import { FiCode, FiMessageSquare, FiTrendingUp } from "react-icons/fi";
import React from "react";

export const serviceCategories = {
  "all-in-one": "All-in-One Growth Package",
  "website-consulting": "Website & App Consulting",
  "design-development": "Design & Development",
  "marketing-growth": "Marketing & Growth",
};

export const services = [
  {
    title: "Website & App Consulting",
    slug: "website-consulting",
    text: "Clarify your goals, define scope, and choose the right digital direction before investing in development.",
    tag: "Great as a starting point",
    icon: <FiMessageSquare className="w-6 h-6" />,
    backgroundWord: "Clarify",
    points: [
      "Business goals & priorities",
      "Tech stack recommendation",
      "Timeline & budget direction",
    ],
    inclusions: [
      "45-60 min video call to understand your business & goals",
      "Review of your current website / app or idea, if you have one",
      "Clarification of target audience, key messages & priorities",
      "Recommendation of suitable tech stack",
      "High-level project scope with rough timeline and budget direction",
      "Simple written action plan",
    ],
  },
  {
    title: "Design & Development",
    slug: "design-development",
    text: "Modern, responsive websites and apps built with clean code and a focus on real business value.",
    tag: "Most requested",
    icon: <FiCode className="w-6 h-6" />,
    backgroundWord: "Build",
    points: [
      "Custom responsive design",
      "Clean implementation",
      "SEO, forms & launch setup",
    ],
    inclusions: [
      "Kickoff call to define structure, pages, and success criteria",
      "Wireframes & simple moodboard for look & feel",
      "Custom responsive design for your key pages",
      "Implementation in a suitable stack",
      "Basic SEO setup with meta tags, page titles, and clean URL structure",
      "Contact forms and basic integrations such as email, booking, or newsletter",
      "Testing on key devices: desktop, tablet, and mobile",
      "Deployment to your domain plus basic handover walkthrough",
    ],
  },
  {
    title: "Marketing & Growth",
    slug: "marketing-growth",
    text: "Social media and simple funnels tailored for small businesses.",
    tag: "For growing businesses",
    icon: <FiTrendingUp className="w-6 h-6" />,
    backgroundWord: "Grow",
    points: [
      "Social media strategy",
      "Content planning & creation",
      "Campaign management & reporting",
    ],
    inclusions: [
      "Define goals, audience, and brand voice",
      "Selection of the right social media platforms",
      "Content strategy and monthly content planning",
      "Creation of posts, captions, and campaign content",
      "Scheduling and publishing of approved content",
      "Setup and management of focused paid social media campaigns where required",
      "Performance tracking with clear recommendations",
    ],
  },
];

export const allInOnePackage = {
  title: "All-in-One Growth Package",
  slug: "all-in-one",
  tag: "Strategy, development, and growth support in one place",
  inclusions: [
    "Full website / app concept, design & development",
    "Strategy discussion to align business goals & digital roadmap",
    "Setup of analytics & basic funnels such as contact → lead → customer",
    "Management of selected marketing channels",
    "Review & optimisation sessions",
    "Ongoing updates and small improvements based on needs",
  ],
};
